module.exports = __webpack_public_path__ + "img/2 - Fast Shutter.74a2bef7.jpeg";